import React from 'react';

// Simple emoji list for demonstration
const EMOJIS = [
    '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣',
    '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰',
    '😘', '😗', '😙', '😚', '😋', '😜', '🤪', '😝',
    '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '😐', '😑',
    '😶', '🙄', '😏', '😣', '😥', '😮', '🤤', '😪',
    '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶',
    '🥳', '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹️',
    '😮‍💨', '😯', '😲', '😳', '🥺', '😦', '😧', '😨',
    '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞',
    '😓', '😩', '😫', '🥱', '😤', '😡', '😠', '🤬',
    '😈', '👿', '💀', '☠️', '🤡', '👹', '👺', '👻',
    '👽', '👾', '🤖', '😺', '😸', '😹', '😻', '😼',
    '😽', '🙀', '😿', '😾'
];

const EmojiPicker = ({ onSelect }) => {
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(8, 1fr)',
            gap: '8px',
            padding: '12px',
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 2px 8px #0002',
            maxWidth: '340px',
            maxHeight: '220px',
            overflowY: 'auto',
        }}>
            {EMOJIS.map((emoji, idx) => (
                <button
                    key={idx}
                    style={{
                        fontSize: '1.7rem',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '6px',
                        transition: 'background 0.2s',
                    }}
                    onClick={() => onSelect(emoji)}
                    aria-label={emoji}
                >
                    {emoji}
                </button>
            ))}
        </div>
    );
};

export default EmojiPicker;
